import React from "react"
import { RouteComponentProps } from "@reach/router"
import * as THREE from "three"
import vert from "../data/vert.glsl"
import frag from "../data/frag.glsl"
import { renderFBO, initFBO, render_target } from "./fbo"

const renderer = new THREE.WebGLRenderer({ antialias: true })
let camera
let fans = []
let start_time = new Date()

let onMouseDown = (event) => {
  event.preventDefault()
  let mouse = new THREE.Vector2()
  mouse.x = event.clientX / window.innerWidth
  mouse.y = 1.0 - event.clientY / window.innerHeight
  fans[0].loc = mouse
  fans[0].power = 0.06
  fans[0].direction = new THREE.Vector2()
    .subVectors(mouse, new THREE.Vector2(0.5, 0.5))
    .multiplyScalar(-1)
    .normalize()
    .multiplyScalar(0.2)
}

let initFans = () => {
  for (let i = 0; i < 1; i++) {
    const loc = new THREE.Vector2(Math.random(), Math.random())
    fans.push({
      loc: loc,
      direction: new THREE.Vector2(
        Math.random() * 2.0 - 1.0,
        Math.random() * 2.0 - 1.0
      ),
      power: 0,
    })
  }
}

initFans()
const texture_dim = 400.0
const tsize = texture_dim * texture_dim
let data = new Float32Array(3 * tsize)
for (let x = 0; x < texture_dim; x++) {
  for (let y = 0; y < texture_dim; y++) {
    let stride = (x + texture_dim * y) * 3
    data[stride] = x / texture_dim
    data[stride + 1] = y / texture_dim
    data[stride + 2] = 0 //ignore for now
  }
}
const texture = new THREE.DataTexture(
  data,
  texture_dim,
  texture_dim,
  THREE.RGBFormat,
  THREE.FloatType
)

initFBO(
  renderer,
  texture,
  texture_dim,
  texture_dim,
  fans.map((f) => f.loc),
  fans.map((f) => f.power),
  fans.map((f) => f.direction)
)

const particle_size = 0.5
const geometry = new THREE.InstancedBufferGeometry()
const positions = new THREE.BufferAttribute(new Float32Array(4 * 3), 3)
positions.setXYZ(0, -particle_size, particle_size, 0.0)
positions.setXYZ(1, particle_size, particle_size, 0.0)
positions.setXYZ(2, -particle_size, -particle_size, 0.0)
positions.setXYZ(3, particle_size, -particle_size, 0.0)
geometry.setAttribute("position", positions)

// uvs
const uvs = new THREE.BufferAttribute(new Float32Array(4 * 2), 2)
uvs.setXY(0, 0.0, 0.0)
uvs.setXY(1, 1.0, 0.0)
uvs.setXY(2, 0.0, 1.0)
uvs.setXY(3, 1.0, 1.0)
geometry.setAttribute("uv", uvs)

// index
geometry.setIndex(
  new THREE.BufferAttribute(new Uint16Array([0, 2, 1, 2, 3, 1]), 1)
)

const indices = new Uint32Array(texture_dim * texture_dim)
for (let i = 0; i < tsize; i++) indices[i] = i

geometry.setAttribute(
  "pindex",
  new THREE.InstancedBufferAttribute(indices, 1, false)
)

const material = new THREE.ShaderMaterial({
  uniforms: {
    mapping: {
      value: render_target.texture,
    },
    dims: {
      value: new THREE.Vector2(texture_dim, texture_dim),
    },
    screen: {
      value: new THREE.Vector2(0, 0),
    },
  },
  vertexShader: vert,
  fragmentShader: frag,
})

const points = new THREE.Mesh(geometry, material)
const scene = new THREE.Scene()
scene.add(points)

const animate = () => {
  const curr_time = new Date()
  renderFBO(
    curr_time.getTime() - start_time.getTime(),
    fans.map((fan) => fan.loc),
    fans.map((fan) => fan.power),
    fans.map((f) => f.direction)
  )
  start_time = new Date()
  material.uniforms.screen.value = new THREE.Vector2(
    window.innerWidth,
    window.innerHeight
  )
  material.uniformsNeedUpdate = true
  material.needsUpdate = true

  renderer.setRenderTarget(null)
  renderer.render(scene, camera)

  requestAnimationFrame(animate)
}

let init = false

const updateViewport = () => {
  camera.left = -window.innerWidth / 2
  camera.right = window.innerWidth / 2
  camera.top = window.innerHeight / 2
  camera.bottom = -window.innerHeight / 2
  camera.updateProjectionMatrix()
  renderer.setSize(window.innerWidth, window.innerHeight)
}

camera = new THREE.OrthographicCamera(
  -window.innerWidth / 2,
  window.innerWidth / 2,
  window.innerHeight / 2,
  -window.innerHeight / 2,
  1,
  1000
)
updateViewport()

camera.position.z = 1
init = true
animate()

document.addEventListener("mousemove", onMouseDown, false)
document.body.appendChild(renderer.domElement)
window.onresize = () => updateViewport()
